import { Link } from "react-router-dom";

const MONOGRAM = "https://static.prod-images.emergentagent.com/jobs/e050023b-6af9-4b95-89f9-f674a8459bbf/images/942f43ea7ec7aa2660a89c5e472f9fe1361511edcd1943438777bc727bfe87e0.jpeg";

export const Logo = ({ size = "md", stacked = false, className = "" }) => {
  const dims = { sm: "h-8", md: "h-10", lg: "h-16", xl: "h-24" }[size] || "h-10";
  const title = { sm: "text-lg", md: "text-2xl", lg: "text-4xl", xl: "text-6xl" }[size] || "text-2xl";
  const sub = { sm: "text-[7px]", md: "text-[9px]", lg: "text-xs", xl: "text-sm" }[size] || "text-[9px]";

  return (
    <Link to="/" data-testid="brand-logo" className={`flex items-center gap-3 group ${stacked ? "flex-col gap-2" : ""} ${className}`}>
      <img src={MONOGRAM} alt="Tactis" className={`${dims} w-auto object-contain transition-transform duration-500 group-hover:scale-105`} style={{ mixBlendMode: "screen" }} />
      <div className={stacked ? "text-center" : ""}>
        <div className={`font-dash font-semibold tracking-[0.18em] text-silver leading-none ${title}`}>TACTIS</div>
        <div className={`${sub} tracking-[0.22em] text-zinc-500 font-medium mt-1`}>
          <span className="text-zinc-300">EXPERT</span> ADVISORY, & MEDIATION
        </div>
      </div>
    </Link>
  );
};
